import React from "react";
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
function SecurityTabItems(props) {
	return (
		<div className="tab-pane" id="security">
			<Row>
				<Col md="4" className="mt-2">
					<div className="box-content">
						<p className="box-head">Firewall</p>
						<p className="box-body">
							Your first line of enterprise grade defense.
						</p>
						<Link className="learn-more" to="/firewall" target="_blank">
							Learn more <span className="learn-arrow"> </span>
						</Link>
					</div>
				</Col>
				<Col md="4" className="mt-2">
					<div className="box-content">
						<p className="box-head">Web Application Firewall</p>
						<p className="box-body">
							Designed to keep your website and applications
							secure.{" "}
						</p>
						<Link className="learn-more" to="/webapplicationfirewall" target="_blank">
							Learn more <span className="learn-arrow"> </span>
						</Link>
					</div>
				</Col>
				<Col md="4" className="mt-2">
					<div className="box-content">
						<p className="box-head">Anti-DDOS</p>
						<p className="box-body">
							We proactively monitor your traffic patterns and
							provide 24/7 remote management, auto detection, and
							risk mitigation against DDoS attacks from
							world-className scrubbing centers.
						</p>
						<Link className="learn-more" to="/antiddos" target="_blank">
							Learn more <span className="learn-arrow"> </span>
						</Link>
					</div>
				</Col>
				<Col md="4" className="mt-2">
					<div className="box-content">
						<p className="box-head">Directory Service</p>
						<p className="box-body">
							Use DETASAD Directory Sync to authenticate and
							integrate your cloud-based work-loads with Microsoft
							AD.
						</p>
						<Link className="learn-more" to="/directoryservice" target="_blank">
							Learn more <span className="learn-arrow"> </span>
						</Link>
					</div>
				</Col>
				<Col md="4" className="mt-2">
					<div className="box-content">
						<p className="box-head">Encryption</p>
						<p className="box-body">
							Do you know the value of your data on the Dark Web?
							Encrypt your data NOW with DETASAD Encryption
							Services for safety and security.
						</p>
						<Link className="learn-more" to="/encryption" target="_blank">
							Learn more <span className="learn-arrow"></span>
						</Link>
					</div>
				</Col>
				<Col md="4" className="mt-2">
					<div className="box-content">
						<p className="box-head">End-Point Protection</p>
						<p className="box-body">
							DETASAD offers one of the most advanced and complete
							endpoint security platforms available on the planet
							to be installed on your instances.
						</p>
						<Link className="learn-more" to="/endpointprotection" target="_blank">
							Learn more <span className="learn-arrow"></span>
						</Link>
					</div>
				</Col>
			</Row>
		</div>
	);
}

export default SecurityTabItems;
